import { api_base } from '../api';
import { dialog } from '../../scripts/confirm';
import { toast } from '../../scripts/toast';
import { router } from '../../routes/routes';
import Actions from '../actions';
import Store from '../store';

export const Projects = {
	// ---- GET ALL ----
	
	get(page = 1, user, cb) {
		$.ajax({
			url: api_base + '/admin/proyects?page=' + page,
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + user.token
			},

			success: function (res) {
				cb(res.data);

				if (res.next_page_url) {
					Projects.get(++page, cb);
				}
			},

			error: function (err) {
				// console.log(err);
			}
		});
	},
	// public.
	getDisplay(page = 1, cb) {
		$.ajax({
			url: api_base + '/proyects',
			method: 'GET',

			success: function (res) {
				cb(res.data);

				if (res.next_page_url) {
					Projects.getDisplay(++page, cb);
				}
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ---- GET BY ID ----

	getById(id, cb) {
		let projects = Store.state.projects;

		if (!projects.length) {
			$.ajax({
				url: api_base + `/proyects/${ id }`,
				method: 'GET',

				success: function (res) {
					cb(res);
				},

				error: function (err) {
					if (err.status == 500) {
						return toast({
							title: 'Servidor',
							content: 'Problemas con el servidor.'
						});
					}

					// console.log(err);
				}
			});
		} else {
			for (let i = 0, p = projects; i < p.length; i++) {
				if (p[i].id == id) {
					cb(p[i]);
				}
			}
		}
	},

	getFullById(id, cb) {
		$.ajax({
			url: api_base + `/proyects/${ id }`,
			method: 'GET',

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ---- CREATE ----

	create(user, project, form, cb) {
		let data = new FormData();
		let images = {};
		let product_ids = {};
		// Set the thumbnail.
		project.thumbnail = project.images[0];
		// Get the images.
		for (let i = 0; i < project.images.length; i++) {
			images['images[' + i + ']'] = project.images[i];
		}

		for (let i = 0, p = project.product_ids; i < p.length; i++) {
			product_ids['product_ids[' + i + ']'] = p[i];
		}
		// Delete the unnecesary images property.
		delete project.images;
		delete project.product_ids;
		// Append the data.
		for (let k in project) {
			data.append(k, project[k]);
		}

		for (let k in product_ids) {
			data.append(k, product_ids[k]);
		}

		for (let k in images) {
			data.append(k, images[k]);
		}

		$.ajax({
			url: api_base + '/admin/proyects',
			method: 'POST',
			data: data,
			cache: false,
			processData: false,
			contentType: false,
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Crear Proyecto',
					content: 'El proyecto se ha creado correctamente.'
				});
				router.go({ name: 'admin_projects' });
				form.is_submited = false;
			},

			error: function (err) {
				toast({
					title: 'Crear Proyecto',
					content: 'El proyecto no se ha creado (llena todos los campos).'
				});
				form.is_submited = false;
				// console.log(err);
			}
		});
	},

	// ---- DELETE ----

	delete(user, project, cb) {
		$.ajax({
			url: api_base + '/admin/proyects/' + project.id,
			method: 'DELETE',
			headers: {
				Authorization: 'Bearer ' + user.token
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Eliminar Proyecto',
					content: 'El proyecto ' + project.title + ' ha sido eliminado.'
				});
			},

			error: function (err) {
				toast({
					title: 'Eliminar Proyecto',
					content: 'Error al eliminar el proyecto.'
				});
				// console.log(err);
			}
		});
	},

	// ---- MOVE ----

	move(user, pos1, pos2, cb) {
		$.ajax({
			url: api_base + `/admin/proyects/move/order?dest=${ pos1 }&to_move=${ pos2 }`,
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				// console.log(res);
			},

			error: function (err) {
				// console.log(err);
			}
		});
	}
};


// WEBPACK FOOTER //
// ./src/store/api/projects.js